var modules=null as any;
var dynamicViewsModules:Record<string, Function>=import.meta.glob('../layout/routerView/*.{vue,tsx}');
modules = import.meta.glob('../layout/routerView/wujie/*.{vue,tsx}');
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules= import.meta.glob('../views/home/*.{vue,tsx}');
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/home/*/*/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B000010/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B000020/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B100BAB/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B100BAE/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B101BAB/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B110BAB/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200BAB/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B201BAB/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B203BAB/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B210BAB/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B800BAB/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B900HAA/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B100001/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B100101/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B100102/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B100112/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B101102/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B100103/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B100105/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules }); 
modules = import.meta.glob('../views/Modules/B103101/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules }); 
modules = import.meta.glob('../views/Modules/B103112/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B103102/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules}); 
modules = import.meta.glob('../views/Modules/B110112/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B115207/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200021/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200031/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200051/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B200052/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200201/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B200221/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200301/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200302/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200350/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200501/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B200502/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules}); 
modules = import.meta.glob('../views/Modules/B203201/*.{vue,tsx}');
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B203301/*.{vue,tsx}');
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules }); 
modules = import.meta.glob('../views/Modules/B300001/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules}); 
modules = import.meta.glob('../views/Modules/B303001/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules}); 
modules = import.meta.glob('../views/Modules/B600001/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B600101/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B800001/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B800002/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B800100/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B800101/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B800102/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B800103/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B800104/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B800105/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B800306/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/B800808/*.{vue,tsx}'); 
dynamicViewsModules = Object.assign({ ...dynamicViewsModules, ...modules });
modules = import.meta.glob('../views/Modules/B801101/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/E400001/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/S700301/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/S700302/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/S700303/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/S700304/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/S700305/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/S700306/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/S700304/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/S900201/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
modules = import.meta.glob('../views/Modules/S900901/*.{vue,tsx}'); 
dynamicViewsModules=Object.assign({...dynamicViewsModules,...modules});
export default dynamicViewsModules;